<template>
  <div
    v-if="templateList"
    class="label-template"
  >
    <div class="input-block input-block_white">
      <label class="input-block__label">
        {{ $t('views.label_template.select_template') }}
      </label>
      <v-autocomplete
        v-model="labelType"
        :loading="loading"
        :disabled="loading"
        :items="templateList"
        :search-input.sync="templateListSearch"
        :placeholder="$t('common.type_to_search')"
        hide-no-data
        solo
      />
    </div>
    <div
      class="mb-5 ml-1"
    >
      <span>{{ $t('views.label_template.current_template') }}</span>
      <span v-if="loading">
        {{ $t('common.loading_data').toLowerCase() }}...
      </span>
      <a
        v-else-if="template"
        :href="template.path"
        :download="template.name"
      >{{ template.name }}</a>
      <span v-else>
        {{ $t('common.no_data').toLowerCase() }}
      </span>
    </div>
    <input
      v-show="false"
      ref="file"
      type="file"
      accept=".xml"
      @change="setFile"
    >
    <button
      :disabled="loading"
      class="btn spso-button spso-button_line spso-button_lowercase label-template__select"
      @click="selectFile"
    >
      {{ $t('views.label_template.select_template') }}
    </button>
    <button
      :disabled="loading"
      class="btn spso-button spso-button_line spso-button_lowercase label-template__save"
      @click="saveTemplate"
    >
      {{ $t('common.save') }}
    </button>
    <div
      v-if="file"
      class="label-template__selected"
    >
      <span class="label-template__selected-label">
        {{ $t('views.label_template.selected_file') }}
      </span>
      <span
        class="label-template__selected-filename"
      >{{ file.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabelTemplate',

  props: {
    templateList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      template: null,
      labelType: null,
      templateListSearch: '',
      file: null,
      loading: false,
    };
  },

  watch: {
    labelType(val) {
      if (!val) {
        return;
      }
      this.loadTemplate();
    },
  },

  created() {
    this.labelType = this.templateList[0]; // eslint-disable-line
  },

  methods: {
    async loadTemplate() {
      try {
        this.loading = true;
        const { data } = await this.$http.get(`/labels/template?type=${this.labelType}`);
        this.template = data;
      } catch (err) {
        this.$http.mockApiError(err);
        this.template = null;
      } finally {
        this.loading = false;
      }
    },

    selectFile() {
      this.$refs.file.value = null;
      this.$refs.file.click();
    },

    setFile() {
      [this.file] = this.$refs.file.files;
    },

    async saveTemplate() {
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append('file', this.file);
        await this.$http.post('/labels/template', formData, {
          headers: { 'label-type': this.labelType },
        });
        await this.loadTemplate();
        this.$refs.file.value = null;
        this.file = null;
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loading = false;
      }
    },

    copyToClipboard(field) {
      navigator.clipboard.writeText(field);
    },
  },
};
</script>

<style lang="scss">
.label-template {
  padding: 25px 25px 30px 25px;
  background-color: #fff;

  &__select {
    margin-right: 20px;
    padding: 12px 25px;
  }

  &__save {
    padding: 12px 25px;
    color: var(--aurum);

    &:hover {
      color: var(--margaritas);
    }
  }

  &__selected {
    height: 50px;
    margin-top: 20px;

    &-label {
      color: var(--platinum);
    }

    &-filename {
      color: var(--topaz);
    }
  }

  &__fields {
    color: var(--topaz);
  }
}
</style>
